import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';

function Contact() {
  const { t } = useTranslation();

  const [name, setName] = useState<string>('');
  const [email, setEmail] = useState<string>('');
  const [message, setMessage] = useState<string>('');


  const form = useRef<HTMLFormElement>(null);

  const sendEmail = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted!', { name, email, message });

    if (name !== '' && email !== '' && message !== '') {
      var templateParams = {
        name: name,
        email: email,
        message: message
      };

      console.log(templateParams);
      emailjs.send('service_tn1kvwv', 'template_z0ppk2f', templateParams, '-jYSNboeUmHKT4l7i').then(
        (response: any) => {
          console.log('SUCCESS!', response.status, response.text);
          alert('Message sent successfully!');
          // Reset form on success
          setName('');
          setEmail('');
          setMessage('');
        },
        (error: any) => {
          console.log('FAILED...', error);
          console.log('Error details:', JSON.stringify(error, null, 2));
          alert(`Failed to send message. Error: ${error.text || error.message || 'Unknown error'}`);
        },
      );
    } else {
      alert('Please fill in all fields before sending.');
    }
  };

  return (
    <div id="contact">
      <div className="items-container">
        <div className="contact_wrapper">
          <h1>{t('contact.title')}</h1>
          <p>{t('contact.subtitle')}</p>
          <Box
            ref={form}
            component="form"
            noValidate
            autoComplete="off"
            className='contact-form'
            onSubmit={sendEmail}
            sx={{ pointerEvents: 'auto' }}
          >
            <div className='form-flex'>
              <input
                type="text"
                placeholder="Your Name"
                value={name}
                onChange={(e) => {
                  console.log('Name input clicked, value:', e.target.value);
                  setName(e.target.value);
                  console.log('Name changed:', e.target.value);
                }}
                onFocus={() => console.log('Name field focused')}
                onBlur={() => console.log('Name field blurred')}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '16px',
                  color: '#000',
                  backgroundColor: '#fff',
                  marginBottom: '10px'
                }}
              />
              <input
                type="text"
                placeholder="Email / Phone"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  console.log('Email changed:', e.target.value);
                }}
                style={{
                  width: '100%',
                  padding: '12px',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  fontSize: '16px',
                  color: '#000',
                  backgroundColor: '#fff',
                  marginBottom: '10px'
                }}
              />
            </div>
            <textarea
              placeholder="Send me any inquiries or questions"
              value={message}
              onChange={(e) => {
                setMessage(e.target.value);
                console.log('Message changed:', e.target.value);
              }}
              style={{
                width: '100%',
                padding: '12px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '16px',
                color: '#000',
                backgroundColor: '#fff',
                marginBottom: '15px',
                minHeight: '120px',
                resize: 'vertical'
              }}
            />
            <Button type="submit" variant="contained" endIcon={<SendIcon />}>
              Send
            </Button>
          </Box>
        </div>
      </div>
    </div>
  );
}

export default Contact;